define( [
	"../../var/pnum"
], function( pnum ) {
	"use strict";

	return new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/css/var/rnumnonpx.js
// module id = x8As
// module chunks = 0 1